import { 
    ACTUALIZAR_PROVEEDORES,
    ACTUALIZAR_PROVEEDORES_DB,
    CARGANDO_PROV,
    ERROR_PROV,
    LIMPIAR_ERROR
} from "./proveedoresActions";

const proveedoresReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_PROVEEDORES:
        case ACTUALIZAR_PROVEEDORES_DB: {
            return {
                ...state,
                proveedores: action.payload,
                cargando: false,
                error: ""
            }
        }

        case CARGANDO_PROV: {
            return {
                ...state,
                cargando: true,
                error: ""
            }
        }

        case ERROR_PROV: {
            return {
                ...state,
                cargando: false,
                error: action.payload
            }
        }

        case LIMPIAR_ERROR: {
            return {
                ...state,
                error: ""
            }
        }

    }
}

export default proveedoresReducer;